import styled from 'styled-components';

export const Container = styled.div`
	border: 1px solid #cccccc;
	padding: 12px 8px 12px 8px;
`;
